import React from 'react';
import styled from 'styled-components';
import {P2} from '../Kit/Kit';
import bg from '../../assets/img/checkBG.png';

const StyledBodyContainer = styled.div`
  position: relative;
  
  @media(min-width: 992px){
     margin-top: 100px;
  }   
  
  margin-bottom: 100px;
`;

const WeHire = styled.h1`
  font-family: Cabin, sans-serif;
  color: #004a87;
  text-align: center;
  z-index: 1;
  font-size: 26px;
  
  @media(min-width: 992px) {
    font-size: 40px;
  }   
`;

const CheckText = P2.extend`
  color: #5d5d5d;
  text-align: center;
  z-index: 2;
`;

const BGImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  display: none;
  
  @media(min-width: 992px) {
    width: 200px;
    display: inline-block;
  }
  
  @media(min-width: 1200px) {
    width: 400px;
  }
`;

const CheckBack = () => {
    return (
      <StyledBodyContainer>
          <WeHire>Apply today to join the H & N family.</WeHire>
          <CheckText>Check back soon to see what's opened up.</CheckText>
          <BGImg src={bg} alt="background"/>
      </StyledBodyContainer>
    );
};

export default CheckBack;



// WEBPACK FOOTER //
// ./src/components/JoinOurTeam/CheckBack.js